import {match} from 'ts-pattern';

import {always, isNotEmpty, isNotNil} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {browserStorageKey, OAUTH_CLIENT_ID} from '@dms/config';

import {iamRedirectRoute} from '../constants/routes';
import {buildUrl} from './buildUrl';
import {getWorkspaceFromUri} from './getWorkspaceFromUri';

export enum iamQueryParams {
  ORIGIN_URI = 'origin_uri',
  CODE = 'code',
  WORKSPACE = 'workspace',
}

export type RedirectToLoginOptions = {
  currentUserEmail?: string | undefined;
  workspace?: string | undefined;
  redirectUrl?: string | undefined;
  additionalQueryParams?: Record<string, string>;
  page?: 'login' | 'reset-password' | 'user-invitation';
};

export const redirectToLogin = (options?: RedirectToLoginOptions) => {
  const iamUrl = process.env.IAM_URL;
  const {workspace} = getWorkspaceFromUri();

  const redirectWorkspace = options?.workspace ?? workspace;

  if (!iamUrl) {
    throw new Error('IAM_URL is not set');
  }

  const page = match(options?.page)
    .with('reset-password', always('reset-password'))
    .with('user-invitation', always('user-invitation'))
    .otherwise(always(''));

  const url = new URL(`${iamUrl}${page}`);

  const originUri = `${window.location.origin}${window.location.pathname}${isNotNilOrEmpty(window.location.search) ? window.location.search : ''}`;
  const nativeRedirect = `${buildUrl(iamRedirectRoute, redirectWorkspace, false)}?${iamQueryParams.ORIGIN_URI}=${encodeURIComponent(originUri)}`;
  const redirect_uri = options?.redirectUrl ?? nativeRedirect;

  const searchParamsConfig = {
    workspace: redirectWorkspace,
    email: options?.currentUserEmail,
    language: localStorage.getItem(browserStorageKey.LAST_KNOWN_LANGUAGE) ?? 'en',
    client_id: OAUTH_CLIENT_ID,
    redirect_uri,
    ...(options?.additionalQueryParams ?? {}),
  };

  Object.entries(searchParamsConfig).forEach(([key, value]) => {
    if (isNotNil(value) && isNotEmpty(value)) {
      url.searchParams.set(key, value);
    }
  });

  window.location.href = url.toString();
};
